import type { ShowcaseReviewsConfigDto } from '@repo/api/web/models'

import { useReviewsConfig } from '../composables/useReviewsConfig'

/**
 * Загружает настройки отзывов витрины (`GET reviews/config`) один раз на SSR — дальше
 * они едут на клиент в payload (useState).
 *
 * Обычный $fetch, а не gateway из DI — причина та же, что в seoConfigLoader: после await
 * nuxt-контекст потерян, а резолв сервисов из контейнера зовёт nuxt-композаблы.
 *
 * dependsOn: host-loader — хост канала пишет он.
 *
 * Ошибка API не роняет страницу: конфиг остаётся null, отзывы и рейтинг просто скрыты.
 * На клиенте при гидратации SSR-страницы конфиг не перезапрашивается: если на SSR он
 * не загрузился, модуль остаётся выключенным до перезагрузки — иначе разметка клиента
 * разошлась бы с серверной (hydration mismatch). Запрос ограничен по времени, чтобы
 * медленный API не задерживал отрисовку страницы.
 */
const CONFIG_TIMEOUT_MS = 3000

export default defineNuxtPlugin({
  name: 'reviews-config-loader:plugin',
  dependsOn: ['host-loader:plugin'],

  async setup(nuxtApp) {
    const state = useReviewsConfig()
    if (state.value) return
    if (import.meta.client && nuxtApp.isHydrating) return

    const runtimeConfig = useRuntimeConfig()
    const appConfig = useAppConfig()

    const apiBase
      = (runtimeConfig.API_BASE_URL as string)
        || (runtimeConfig.public.API_BASE_URL as string)
    const host = appConfig.host

    if (!apiBase || !host) return

    try {
      state.value = await $fetch<ShowcaseReviewsConfigDto>(
        `${apiBase}/showcases/v1/${host}/reviews/config`,
        { timeout: CONFIG_TIMEOUT_MS },
      )
    } catch (error) {
      console.warn('[reviews] не удалось загрузить reviews/config:', error)
    }
  },
})
